import {Module} from "vuex";
import api from "@/services/apiService";
import {AxiosResponse} from "axios";
import router from "@/router";
import {User, UserAPIInterface} from "@/entity/User";
import {ErrorService} from "@/services/ErrorService";

const authModule: Module<any, any> = {
  state: {
    user: new User() as UserAPIInterface,
  },
  getters: {
    isAuthenticated(state) {
      return typeof state.user.id !== "undefined";
    },
    isAdmin(state) {
      return state.user?.roles?.includes('ROLE_ADMIN');
    },
    getUser(state) {
      return state.user;
    },
  },
  mutations: {
    login(state, user) {
      state.user = user;
      localStorage.setItem('user', JSON.stringify(user));
    },
    async logoutMutation(state) {
      state.user = await new User();
    }
  },
  actions: {
    async logout({commit, state}) {
      await api.apiRequest.get('logout')
        .then((response: AxiosResponse) => {
          commit('logoutMutation');
          localStorage.setItem('user', JSON.stringify(new User));
        })
        .catch((error: any) => {
          ErrorService.dealWithTheError(error);
        });
    },
  }
};

export default authModule;
